"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
const functions_1 = require("../../functions");
function propertyDefinition(pvs) {
    const flows = (0, functions_1.getFlows)(pvs);
    return [
        ...flows.map((_, i) => ({
            sort_no: i,
            name: (0, functions_1.flowName)(i),
            group: "",
            quantity: "VolumeFlow",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString("temperatureflow=1"),
            value: [],
            fieldName: functions_1.flowPrefix
        }))
    ];
}
//# sourceMappingURL=flows-definition.js.map